<template>
  <div class="editor-container">
    <vue-monaco-editor
      ref="editor"
      theme="vs"
      :options="MONACO_EDITOR_OPTIONS"
      :language="language"
      v-model="text"
      @change="handleChange"
    >
      <div style="height: 100%">Carregando editor...</div>
      <template #failure>
        <div style="height: 100%">Falha ao iniciar o editor</div>
      </template>
    </vue-monaco-editor>
  </div>
</template>

<script>
export default {
  name: "MonacoEditor",
  props: {
    sql: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: "sql"
    }
  },
  data() {
    return {
      text: this.sql,
      MONACO_EDITOR_OPTIONS: {
        automaticLayout: true,
        formatOnType: true,
        formatOnPaste: true,
        renderLineHighlight: "none",
        minimap: {
          enabled: false
        },
        scrollbar: {
          vertical: "hidden",
          horizontal: "hidden"
        },
        wordWrap: "on",
        wordWrapColumn: 0,
        wrappingIndent: "same",
        scrollBeyondLastColumn: 0,
        glyphMargin: false,
        folding: false,
        contextmenu: false,
        overviewRulerLanes: 0,
        overviewRulerBorder: false,
        selectionHighlight: false,
        quickSuggestions: {
          other: true,
          comments: false,
          strings: true
        },
        suggestOnTriggerCharacters: true,
        acceptSuggestionOnEnter: "on",
        acceptSuggestionOnCommitCharacter: true,
        tabSize: 2,
        insertSpaces: true,
        autoClosingBrackets: "always",
        autoClosingQuotes: "always",
        autoIndent: "advanced",
        renderWhitespace: "none",
        renderControlCharacters: false,
        matchBrackets: "always"
      }
    };
  },
  methods: {
    handleChange(val, event) {
      this.$emit("sql", val);
    },
    setQuery(val) {
      this.text = val;
      this.$emit("sql", this.text);
    }
  }
};
</script>

<style scoped>
.editor-container {
  /* height: 100% foi removido */
  flex: 1 1 auto;
  min-height: 0; /* Essencial para permitir o encolhimento */
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.editor-container > * {
  flex: 1 1 auto;
  min-height: 0;
}
</style>
